import {observer} from "mobx-react-lite";
import React from "react";
import Skeletons from "./Skeletons";
import {Navigation, Autoplay} from "swiper";
import {Swiper, SwiperSlide} from "swiper/react";
import {MobileContainer} from "../../../Global/Global";
import {SwiperNavigationWrapper} from "../../../../Utilities/postUtils";
import PostCardStatic from "../../../Posts/PostCard";
import {Title} from "../../FrontPage";
import { frontpageStore } from "../../../../Stores/FrontpageStore";


function LatestPosts() {

    const SwiperSlider = () => {
        return <SwiperNavigationWrapper>
            <Swiper
                style={{
                    height: "auto",
                    padding: "5px 0px",
                }} // Color of the navigation arrows
                navigation={true} // Show navigation arrows
                spaceBetween={15}
                slidesPerView={"auto"}
                slidesPerGroupAuto={true}
                modules={[Navigation, Autoplay]} // Enable navigation module
                speed={500}
                autoplay={{
                    delay: 10000,
                    disableOnInteraction: false,
                }}
            >
                {frontpageStore.latestPosts.map((post, index) =>
                    <SwiperSlide
                        style={{
                            width: "auto",
                            textAlign: "start",
                        }}
                        key={`font-page-swiper-${index}`
                        }>
                        <PostCardStatic
                            key={post.PostId}
                            postId={post.PostId}
                            imageUrl={post.Images[0]?.Url}
                            price={post.Price}
                            heading={post.Heading}
                            body={post.Body}
                            highlight={post.Highlight}
                        />
                    </SwiperSlide>
                )}
            </Swiper>
        </SwiperNavigationWrapper>
    }

    return (
        <MobileContainer>
            <Title title={"Sidst oprettet"}/>
            {frontpageStore.latestPosts.length > 0
                ? <SwiperSlider/>
                : <Skeletons/>
            }
        </MobileContainer>
    );
}

export default observer(LatestPosts);